import CompleteTableData from "../../../../../../../../app/common-components/Table/CompleteTableData";
import FirstSeenOffsetConfigPopup from "../../../FirstSeenOffsetConfig/FirstSeenOffsetConfigPopup";

import React,{ memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCommonAlert } from "../../../../../../../../app/utilities/helpers";
import { FirstSeenOffsetConfigList, saveFirstSeenOffsetConfig } from "../../../../ToolsSlice";

const FirstSeenOffsetConfiguration = () => {
  const dispatch = useDispatch();
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();

  // Get loading state from Redux
  const saveLoading = useSelector((state) => state.saveFirstSeenOffsetConfigLoading || false);

  const [state, setState] = useState({
    loading: false,
    tableData: [],
    totalCount: 0,
    pageNo: 0,
    pageLimit: 10,
    searchKey: "",
    addBodyOpenInfo: false,
    addBodyOpenAdd: false,
    modelRowData: null,
  });
  useEffect(() => {
    loadData(state.pageNo, state.pageLimit);
  }, [state.pageNo, state.pageLimit]);


  const loadData = async (pageNo, pageLimit) => {
    setState((s) => ({ ...s, loading: true }));
    try {
      const res = await dispatch(
        FirstSeenOffsetConfigList({
          pageNumber: pageNo,
          itemsPerPage: pageLimit,
          payload: {
            keyword: "",
            sortByColumn: "",
            sortOrder: "",
          },
        })
      ).unwrap();

      setState((s) => ({
        ...s,
        tableData: res.data || [],
        totalCount: res.totalCount || 0,
      }));
    } catch (err) {
      console.error("API failed:", err);
      // Optional: store an error message
      setState((s) => ({ ...s, error: err }));
    } finally {
      // Always runs — even on 500, 404, 400, or an unexpected cosmic sneeze
      setState((s) => ({ ...s, loading: false }));
    }
  };

  const columns = [
    {
      Header: "Overdue Calculation Based On",
      accessor: "overdueBasedOn",
      tdClassName: "text-center",
    },
    {
      Header: "Fields Shown In VM Details Table",
      accessor: "vmTableFields",
      tdClassName: "text-center",
      Cell: ({ value }) => {
        return value !== undefined && value !== null && value !== ""
          ? value
          : "-";
      }
    },
    {
      Header: "Updated By",
      accessor: "createdBy",
      tdClassName: "text-center",
      Cell: ({ value }) => {
        return value !== undefined && value !== null && value !== ""
          ? value
          : "-";
      }
    },
    {
      Header: "Updated On",
      accessor: "createdOn",
      tdClassName: "text-center",
      Cell: ({ value }) =>
        value ? new Date(value).toLocaleString("en-IN") : "-",
    },
  ];

  const infoModalBody = () => (
    <>
      <h4>Information</h4>
      <table className="table">
        <tbody>
          <tr>
            <th>Updated By</th>
            <td>{state.modelRowData?.updatedBy || "-"}</td>
          </tr>
          <tr>
            <th>Updated On</th>
            <td>
              {state.modelRowData?.updatedOn
                ? new Date(state.modelRowData.updatedOn).toLocaleString()
                : "-"}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
  const addAddBodyOpen = (row = null) => {
    setState((prev) => ({
      ...prev,
      addBodyOpenAdd: true,
      modelRowData: row, // null = Add, row = Edit
    }));
  };
  const addAddBodyClose = () => {
    setState((prev) => ({
      ...prev,
      addBodyOpenAdd: false,
      modelRowData: null,
    }));
  };

  const handleFirstSeenOffsetSave = (formData) => {
    setState((s) => ({ ...s, loading: true }));

    dispatch(saveFirstSeenOffsetConfig(formData))
      .then(async (data) => {
        const status = data?.payload?.status;

        if (status === 200) {
          callCommonAlert("success", data.payload.message);
          hideCommonAlert();
          setState((prev) => ({
            ...prev,
            pageNo: 0,
            pageLimit: 10,
            searchKey: "",
          }));
          // Reload table
          await loadData(state.pageNo, state.pageLimit);

          // Close modal
          addAddBodyClose();
        }
        else if (status === 205) {
          callCommonAlert("error", data.payload.message);
          hideCommonAlert();
        }
        else if (status === 409) {
          callCommonAlert("warning", data.payload.message);
          hideCommonAlert();
        }
        else {
          callCommonAlert("error", "First Seen Offset Configuration Failed to save");
          hideCommonAlert();
        }
      })
      .catch((error) => {
        console.error("Save error:", error);
        callCommonAlert("error", "First Seen Offset Configuration Failed to save");
        hideCommonAlert();
      })
      .finally(() => {
        setState((s) => ({ ...s, loading: false }));
      });
  };

  const handlePageNoChange = (pageNo) => {
    setState((prev) => ({
      ...prev,
      pageNo: pageNo,
    }));
    loadData(pageNo, state.pageLimit);
  };

  const handlePageLimitChange = (pageLimit) => {
    setState((prev) => ({
      ...prev,
      pageLimit: pageLimit,
    }));
    loadData(state.pageNo, pageLimit);
  };


  return (
    <>
      <CompleteTableData
        title="First Seen Offset Configuration"
        TableTitle={"First Seen Offset Configuration"}
        isLoading={state.loading}
        data={state.tableData}
        columns={columns}
        listCount={state.totalCount}
        pageLimit={state.pageLimit}
        curentPageNumber={state.pageNo}
        totalPageCount={Math.ceil(state.totalCount / 10)}
        moveSearchToEnd={true}
        onPageNoChange={handlePageNoChange}
        onPageLimitChange={handlePageLimitChange}

        btnData={[
          {
            text: "Configure",
            className: "solid-btn",
            disabled: false,
            function: () => {
              addAddBodyOpen(state.tableData[0] || null);
            },
          },
        ]}
      />

      <FirstSeenOffsetConfigPopup
        isOpen={state.addBodyOpenAdd}
        onClose={addAddBodyClose}
        onSave={handleFirstSeenOffsetSave}
        initialData={state.modelRowData}
        isLoading={saveLoading}
      />

    </>
  );
};

export default memo(FirstSeenOffsetConfiguration);
